export default (store) => {
  return ({
    path: 'send-link' ,
    getComponent(nextState, cb) {
      const Offer = require('./containers').default
      cb(null, Offer)
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/SendCampaignMessage/index.js